import { useUserData } from 'Foundation/User/UserContext';
import { useState, FunctionComponent, useEffect } from 'react';
import './PersonalizationRow.scss';
import { IconIgnite } from '@lmig/lmds-react-icons';

interface IPersonalizationRow {
  linkurl: string;
  linktarget: string;
  richtext: string;
}

const PersonalizationRow: FunctionComponent<any> = (props: IPersonalizationRow) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [welcomeMsg, setWelcomeMsg] = useState<string>('');
  const [hideTierButton, setHideTierButton] = useState<boolean>(true);
  const { userData } = useUserData();

  useEffect(() => {
    if (userData) {
      if ((userData.isAgent() || userData.isMockingAgent) && userData.firstName()?.trim().length > 0) {
        setWelcomeMsg(userData.firstName() + '!');
      } else if (!userData.isAgent()) {
        setWelcomeMsg('Liberty Mutual employee!');
      }

      if (userData.selectedStatCodeData?.Tier) {
        setHideTierButton(false);
      }
      setIsLoaded(true);
    }
  }, [userData]);

  return isLoaded ? (
    <div className="personalization-row">
      {(welcomeMsg?.length > 0 || props?.richtext?.length > 0) && (
        <div className="welcomeMsgSection">
          <div className="welcomeMsg">Hi</div>
          {welcomeMsg?.length > 0 && (
            <div>
              <p className="welcomeMsgName">{welcomeMsg}</p>
            </div>
          )}
          {props?.richtext?.length > 0 && (
            <div id="personalization-row-rich-text" dangerouslySetInnerHTML={{ __html: props.richtext }}></div>
          )}
        </div>
      )}
      {!hideTierButton && userData && props?.linkurl && (
        <a className="buttonSectionWrapper" href={props.linkurl} target={props.linktarget}>
          <span>
            <IconIgnite size="16" />
          </span>
          <div className="buttonSection">{userData.selectedStatCodeData.Tier}</div>
        </a>
      )}
    </div>
  ) : (
    <></>
  );
};

export default PersonalizationRow;
